// #3185 APPROVE.2 PR 2c (ruling 6531162587 item 1) — the pre-enforcement
// notice on the three client approval matrix screens: the workspace settings
// page, the project override panel and the partner default matrix (Partner
// Portal, onboarding wizard, managed-client form). Nothing enforces the rows
// these screens save until APPROVE.3 switches it on (ruling D1 a).
//
// TODO(APPROVE.3 3b, #3186): remove at switch-on — delete this file and its
// three uses; 3b's test proves the notice is gone.

export const PRE_ENFORCEMENT_NOTICE =
  'These settings are saved now. Client approval enforcement turns on in an upcoming release.';

export default function PreEnforcementNotice() {
  return (
    <p
      role="note"
      data-testid="client-approvals-pre-enforcement-notice"
      style={{
        fontFamily: 'var(--font-body)',
        fontSize: 13,
        color: 'var(--text)',
        background: 'var(--surface-alt)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius-sm)',
        padding: '8px 12px',
        margin: '0 0 16px',
      }}
    >
      {PRE_ENFORCEMENT_NOTICE}
    </p>
  );
}
